import styled, { keyframes } from 'styled-components';
import { breakpoint, theme } from '../../../../theme';
import { Badge, LotBadge } from '../../../badge';
import { Pill } from '../../../basePill';
import { BaseBodyTextStyles, UIText } from '../../../typography';
import { Medal } from '../../../medal';
import { WineBadge } from '../../../wineBadge';

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
`;

export const ResponsiveImageContainer = styled(ImageContainer)`
  max-height: 165px;
`;

export const FeaturedImageContainer = styled(ImageContainer)`
  max-height: 136px;
`;

export const Image = styled.img<{ width?: string; minHeight?: string }>`
  overflow: hidden;
  object-fit: contain;
  width: 100%;
  min-height: ${({ minHeight = '136px' }) => minHeight};
`;

export const Title = styled.h2.attrs({ size: 'sm' })`
  ${BaseBodyTextStyles}
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 40px;
`;

export const GrayUIText = styled(UIText).attrs({ size: 'xs' })`
  display: flex;
  gap: ${theme.spacings[1].rem};
  align-items: center;
  white-space: nowrap;
  color: ${theme.colors.neutrals.solidGrays[3]};
`;

export const BlackUIText = styled.span`
  display: flex;
  gap: ${theme.spacings[1].rem};
  align-items: center;
  white-space: nowrap;
  color: ${theme.colors.primary.graysGray};
`;

export const UnitPriceText = styled(UIText).attrs({ size: 'xs' })``;

export const DisclaimerContentText = styled(UIText).attrs({ size: 'xxs' })`
  display: flex;
  gap: ${theme.spacings[1].rem};
  align-items: center;
  color: ${theme.colors.neutrals.solidGrays[3]};
`;

export const StyledBadge = styled(Badge)`
  position: relative;
  left: 0;
  top: ${theme.spacings[2].rem};
  font-size: 12px;
`;

export const StyledMedal = styled(Medal)`
  position: relative;
  left: 0;
  top: ${theme.spacings[2].rem};
  z-index: 0;
`;

export const StyledLotBadge = styled(LotBadge)`
  position: relative;
  top: ${theme.spacings[2].rem};
  left: ${theme.spacings[1].rem};
  z-index: 0;
  :nth-of-type(4) {
    display: none;
  }
`;

export const StyledWineBadge = styled(WineBadge)`
  position: relative;
  left: 0;
  top: ${theme.spacings[2].rem};
  z-index: 0;
  :nth-child(4) {
    display: none;
  }
  ${breakpoint('md')`
    :nth-child(4) {
    display: flex;
  }
  `};
`;

export const Price = styled.div`
  ${theme.typography.headings[5]['sm-lg']};
  color: ${theme.colors.primary.graysRed};
`;

export const GrayPrice = styled.div`
  ${theme.typography.body.sm};
  color: ${theme.colors.neutrals.solidGrays[3]};
  margin-bottom: ${theme.spacings[1].rem};
`;

export const BottomContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`;

export const ReserveBarTimerWrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
`;

export const DesktopReserveBarTimerWrapper = styled(ReserveBarTimerWrapper)`
  align-items: center;
  min-height: 24px;
`;

export const FeaturedReserveBarTimerWrapper = styled(ReserveBarTimerWrapper)`
  flex-wrap: wrap;
  white-space: nowrap;
  gap: ${theme.spacings[1].rem};
  align-items: center;
`;

export const StyledDeliveryPill = styled(Pill)`
  position: absolute;
  right: ${theme.spacings[2].rem};
  bottom: ${theme.spacings[2].rem};
`;

export const WatchButtonContainer = styled.div`
  position: absolute;
  top: ${theme.spacings[2].rem};
  right: ${theme.spacings[2].rem};
`;

export const highlightCard = keyframes`
  0% {
    box-shadow: 0px 4px 8px ${theme.colors.neutrals.transparentGrays[6]};
  }
  50% {
    box-shadow: 0px 4px 8px ${theme.colors.system.systemBlue};
  }
  100% {
    box-shadow: 0px 4px 8px ${theme.colors.neutrals.transparentGrays[6]};
  }
`;

export const SearchCardContainerBase = styled.a`
  box-shadow: 0px 4px 4px ${theme.colors.neutrals.transparentGrays[6]};
  border-radius: 4px;
  text-decoration: none;

  transition: all 300ms ease;

  &:hover {
    box-shadow: 0px 8px 16px ${theme.colors.neutrals.transparentGrays[6]};
  }

  &.highlight {
    animation: 3s ${highlightCard} ease-in-out;
  }
`;
